<ng-container *ngIf="activePanel$ | async as activePanel">
    <span *ngIf="activePanel !== 'navigation'">{{getToolDisplayName(activePanel) | trans}}</span>
    <span *ngIf="activePanel === 'navigation'" trans>Editor</span>
</ng-container>
